/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloCache, DefaultContext, OperationVariables } from '@apollo/client';
import { useApolloMutation, useCookie } from '@netfront/common-library';
import { useGetProduct } from '@netfront/gelada-identity-library';

import { IUseCustomMutationOptions } from './useCustomMutation.interfaces';

const useCustomMutation = <
  TData = unknown,
  TVariables extends OperationVariables = OperationVariables,
  TContext = DefaultContext,
  TCache extends ApolloCache<unknown> = ApolloCache<unknown>,
>({
  authTokensCookieOptionalAttributes,
  customBuildGuid,
  mutation,
  onUnauthenticated,
  options,
  product,
  projectId,
  requestCredentials,
  tokens,
  apiName,
}: IUseCustomMutationOptions<TData, TVariables, TContext, TCache>) => {
  const { getTemporaryTokenCookie } = useCookie();
  const { getProduct } = useGetProduct();

  const temporaryToken = getTemporaryTokenCookie();
  const definedProduct = product ?? getProduct();


  return useApolloMutation<TData, TVariables, TContext, TCache>({
    apiName,
    authTokensCookieOptionalAttributes,
    customBuildGuid,
    isPublic: false,
    mutation,
    onUnauthenticated,
    options,
    product: definedProduct,
    projectId,
    requestCredentials,
    tokens:
      tokens ??
      (temporaryToken
        ? {
            accessToken: temporaryToken,
            refreshToken: '',
          }
        : undefined),
  });
};

export { useCustomMutation };
